// src/utils/globalFunctions.js
export function sayHello(name) {
  alert('Hello, ' + name);
}

//设置登录token时效
export function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

//获取token信息，如果过期就删除
export function getWithExpiry(key) {
  console.log("getWithExpiry")
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (itemStr) {
    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the current time with the expiry time of the item
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  // 2️⃣ localStorage 没有，尝试从 cookie 读取
  let cookieValue = getCookie(key);
  if (cookieValue) {
    const cookieItem = JSON.parse(cookieValue);
    if (new Date().getTime() > cookieItem.expiry) {
      return null; // 过期了
    }
    // ✅ 存入 localStorage 方便后续使用
    localStorage.setItem(key, JSON.stringify(cookieItem));
    return cookieItem.value;
  }
  return null; // localStorage 和 cookie 都没有
}

// 从 cookie 获取数据
function getCookie(cookieName) {
  let strCookie = document.cookie;
  let arrCookie = strCookie.split("; ");
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split("=");
    if (cookieName === arr[0]) {
      return decodeURIComponent(arr[1]);
    }
  }
  return "";
}

export function getWithExpiryTime(key) {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  return item.expiry;
}